module.exports = __webpack_public_path__ + "static/playground-7abe4fd0724326c0ea896451e36cb1a4.jpg";